'use client'

// What sits over the Pino cam on a stream.
//
// The site's buttons and panels are for somebody at the controls; a
// stream has nobody at the controls, and a viewer on a phone in a chat
// window needs two things at a glance: what he is doing and why, and
// where this is. Big type, few words, nothing to click.
//
// His line comes off the NPC delta (the same sentence the status line
// uses).

import useGameStore from '../../stores/gameStore'
import { kawaii, ui } from '../../lib/ui/theme'

const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s)

const card = {
  background: 'rgba(247,231,210,0.94)',
  border: kawaii.outline,
  borderRadius: 18,
  boxShadow: kawaii.drop,
  padding: '14px 20px',
  fontFamily: ui.font,
  color: kawaii.ink,
}

export function StreamOverlay() {
  const now = useGameStore((s) => s.npcStates?.[0]?.now || null)
  const view = useGameStore((s) => s.pinoCam)

  return (
    <div className="fixed inset-0 z-40 pointer-events-none select-none" style={{ fontFamily: ui.font }}>
      <div className="absolute" style={{ top: 22, left: 26, display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{ width: 12, height: 12, borderRadius: 999, background: '#e5484d', boxShadow: '0 0 0 3px rgba(229,72,77,0.3)' }} />
        <span style={{ color: '#fdf6ea', fontSize: 20, fontWeight: 850, textShadow: '0 2px 8px rgba(0,0,0,0.55)' }}>
          {view === 'eyes' ? 'live through Pino\u2019s eyes' : 'live, following Pino'}
        </span>
      </div>

      {now?.doing && (
        <div className="absolute" style={{ left: 26, bottom: 26, maxWidth: 'min(56vw, 760px)', ...card }}>
          <p style={{ fontSize: 26, fontWeight: 850, lineHeight: 1.2 }}>{cap(now.doing)}</p>
          {now.why && <p style={{ fontSize: 18, fontWeight: 650, color: kawaii.inkSoft, marginTop: 4, lineHeight: 1.35 }}>{cap(now.why)}</p>}
        </div>
      )}

      <div className="absolute" style={{ right: 26, bottom: 26, ...card }}>
        <p style={{ fontSize: 15, fontWeight: 800, color: '#5f42ab' }}>pinos.world</p>
      </div>
    </div>
  )
}

export default StreamOverlay
